import { render } from "./IconCalendar.vue?vue&type=template&id=a6588b26"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/icon/IconCalendar.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a6588b26"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a6588b26', __exports__)) {
    api.reload('a6588b26', __exports__)
  }
  
  module.hot.accept("./IconCalendar.vue?vue&type=template&id=a6588b26", () => {
    api.rerender('a6588b26', render)
  })

}


export default __exports__